import React, { type ReactElement } from 'react'
import { Menu } from '@/payload-types'
import { CMSLink } from '@/components'

interface GlobalFooterLegalProps {
  nav?: Menu
}

function GlobalFooterLegal({ nav }: Readonly<GlobalFooterLegalProps>): ReactElement | null {
  return (
    <div className="max-w-screen-2xl mx-auto text-xs mt-4 pt-4 flex flex-col gap-4 lg:flex-row lg:justify-between border-t">
      <ul className="list-none flex flex-row items-center justify-center gap-4 lg:justify-start">
        <li>&copy; 2025 OREME</li>
        <li>Photos &copy; CNRS Photothèque</li>
      </ul>
      <ul className="list-none flex flex-row items-center justify-center gap-4 lg:justify-start">
        {nav ? (
          <ul className="list-none flex flex-row gap-6 justify-center items-center border-t p-4 2xl:pr-0 lg:ml-auto lg:border-l lg:border-t-0">
            {nav.items.map(({ id, link }) => {
              return (
                <li key={id}>
                  <CMSLink {...link} appearance="inline" />
                </li>
              )
            })}
          </ul>
        ) : null}
      </ul>
    </div>
  )
}

export { GlobalFooterLegal }
